import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { FlightsPage } from "@/features/reporting/components/flights-page";
import { resolveBoundedPeriod } from "@/features/reporting/lib/period";

const layoutRoute = getRouteApi("/_authed/_dashboard/reporting");

export const Route = createFileRoute("/_authed/_dashboard/reporting/vols")({
  component: ReportingFlightsRoute,
});

function ReportingFlightsRoute() {
  const search = layoutRoute.useSearch();

  return (
    <FlightsPage
      period={resolveBoundedPeriod("/reporting/vols", search.period)}
      filters={{ tenantId: search.tenantId, companyId: search.companyId }}
    />
  );
}
